import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const BASE = API_URL + "/admin/phonebot-versions";

export default {
    async list() {
        const response = await axios.get(BASE, { headers: authHeader() });
        return response.data.data;
    },

    async show(id) {
        const response = await axios.get(`${BASE}/${id}`, { headers: authHeader() });
        return response.data.data;
    },

    async create(version) {
        const response = await axios.post(BASE, version, { headers: authHeader() });
        return response.data.data;
    },

    async update(id, version) {
        const response = await axios.patch(`${BASE}/${id}`, version, { headers: authHeader() });
        return response.data.data;
    },

    async activate(id) {
        const response = await axios.post(`${BASE}/${id}/activate`, {}, { headers: authHeader() });
        return response.data.data;
    },

    async remove(id) {
        await axios.delete(`${BASE}/${id}`, { headers: authHeader() });
    },
};
